<template>
  <div class="custom-footer">
    <b-container>
      <div class="footer">
        <b-col cols="12" class="sm-px-0" style="padding: 0 12px">
          <b-row class="footer-row d-flex">
            <b-col cols="12" lg="8" md="12" class="footer-access">
              <b-row class="access-row">
                <b-col cols="5" lg="3" md="4" class="access-row__col">
                  <h3>دسترسی سریع</h3>
                  <router-link :to="{ name: 'Home' }">
                    <h4 class="p-fw-m mt-4 me-2">
                      <b-icon icon="circle-fill" class="p-fs-xs ms-2"></b-icon>
                      صفحه نخست
                    </h4>
                  </router-link>
                  <router-link
                    :to="{ name: 'AboutOrganization', params: { id: 1 } }"
                  >
                    <h4 class="p-fw-m mt-4 me-2">
                      <b-icon icon="circle-fill" class="p-fs-xs ms-2"></b-icon>
                      ارتباط با ما
                    </h4>
                  </router-link>
                  <router-link :to="{ name: 'CountactUs' }">
                    <h4 class="p-fw-m mt-4 me-2">
                      <b-icon icon="circle-fill" class="p-fs-xs ms-2"></b-icon>
                      تماس با ما
                    </h4>
                  </router-link>
                </b-col>
                <b-col lg="4" md="4" class="hideResponsive pe-4">
                  <h3>محصولات و خدمات</h3>
                  <router-link :to="{ name: 'Video' }">
                    <h4 class="p-fw-m mt-4 me-2">
                      <b-icon icon="circle-fill" class="p-fs-xs ms-2"></b-icon>
                      فیلم‌ها
                    </h4>
                  </router-link>
                  <router-link :to="{ name: 'Podcast' }">
                    <h4 class="p-fw-m mt-4 me-2">
                      <b-icon icon="circle-fill" class="p-fs-xs ms-2"></b-icon>
                      صوت‌ها
                    </h4>
                  </router-link>
                  <router-link :to="{ name: 'NewsList' }">
                    <h4 class="p-fw-m mt-4 me-2">
                      <b-icon icon="circle-fill" class="p-fs-xs ms-2"></b-icon>
                      آخرین اخبار
                    </h4>
                  </router-link>
                  <router-link :to="{ name: 'Gallery' }">
                    <h4 class="p-fw-m mt-4 me-2">
                      <b-icon icon="circle-fill" class="p-fs-xs ms-2"></b-icon>
                      گالری تصاویر
                    </h4>
                  </router-link>
                  <router-link :to="{ name: 'Home' }">
                    <h4 class="p-fw-m mt-4 me-2">
                      <b-icon icon="circle-fill" class="p-fs-xs ms-2"></b-icon>
                      آخرین مطالب
                    </h4>
                  </router-link>
                </b-col>
                <b-col cols="7" lg="5" md="4" class="access-row__link">
                  <h3>پیوندها</h3>
                  <a :href="item.url" v-for="item in items" :key="item.id">
                    <h4 class="p-fw-m mt-4 me-2">
                      <b-icon icon="circle-fill" class="p-fs-xs ms-2"></b-icon>
                      {{ item.title }}
                    </h4>
                  </a>
                  <!-- <router-link :to="{ name: 'Home' }">
                    <h4 class="p-fw-m mt-4 me-2">
                      <b-icon icon="circle-fill" class="p-fs-xs ms-2"></b-icon>
                      دفتر همکاری‌های علمی و بین الملل
                    </h4>
                  </router-link>
                  <router-link :to="{ name: 'Home' }">
                    <h4 class="p-fw-m mt-4 me-2">
                      <b-icon icon="circle-fill" class="p-fs-xs ms-2"></b-icon>
                      انتشارات دانشگاه قم
                    </h4>
                  </router-link>
                  <router-link :to="{ name: 'Home' }">
                    <h4 class="p-fw-m mt-4 me-2">
                      <b-icon icon="circle-fill" class="p-fs-xs ms-2"></b-icon>
                      صندوق تعاون کارکنان
                    </h4>
                  </router-link> -->
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="4" class="pe-3 footer-address">
              <div
                class="d-flex align-items-center mb-5 pb-4 footer-address__logo"
                style="margin-top: -15px"
              >
                <img src="@/assets/images/logo/03.png" width="42px" />
                <h3 class="p-fw-normal mb-0 me-2">
                  سازمان تبلیغات اسلامی استان مازندران
                </h3>
              </div>
              <div class="d-flex align-items-center">
                <span class="icon-address p-fs-big"></span>
                <h5 class="p-fw-normal p-lh-n me-2">
                  آدرس: &nbsp;
                  <span class="me-1">
                    {{ addressItems.address }}
                  </span>
                </h5>
              </div>
              <div class="d-flex align-items-center mt-4 sm-mt-3">
                <span class="icon-phone1 p-fs-xxxl"></span>
                <h5 class="p-fw-normal me-2">
                  تلفن: &nbsp;
                  <span class="me-1">{{ addressItems.phone }}</span>
                </h5>
                <h5 class="p-fw-normal me-3">
                  دورنگار: &nbsp;
                  <span class="me-1">{{ addressItems.fax }}</span>
                </h5>
              </div>
              <div class="d-flex align-items-center mt-4 sm-mt-3">
                <span class="icon-email p-fs-xxxl"></span>
                <h5 class="p-fw-normal me-2">
                  پست الکترونیک:
                  <span class="me-1">{{ addressItems.email }}</span>
                </h5>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheFooter",

  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      items: "newsX/links",
      addressItems: "newsX/contactUs",
    }),
  },
  methods: {},
  beforeCreate() {
    this.$store.dispatch("newsX/getLinks");
    this.$store.dispatch("newsX/getContactUs");
  },
};
</script>
<style lang="sass"></style>
